var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (false)?_c('div',[_vm._t("header"),_vm._t("body"),_vm._t("summary"),_vm._t("filter")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }